module.exports = __webpack_public_path__ + "img/tgg-2.78033bd2.webp";